<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="900px">
    <div style="text-align: left">
      <div class="__div">
        <span class="title__span">所属库区: </span>
        <el-select v-model="region" placeholder="来源(可搜索)" filterable>
          <el-option :label="item.regionName" :value="item.id" v-for="item in regionList" :key="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <div style="padding:0 100px 10px 100px;">库区</div>
        <el-input maxlength='450' v-model="Initials" style="width: 260px;padding-left: 100px;margin-bottom: 10px;"
          placeholder="如：A">
        </el-input>
      </div>
      <CodeBuild class="aisle-code" v-model="aisle" format="PN" title="通道">
        <div class="aisle-suffix">
          <div class="aisle-suffix__label">通道后缀(非必须，如A,B,C等)</div>
          <el-input v-model="aisleSuffix" maxlength="10" style="width: 200px" />
        </div>
      </CodeBuild>
      <!-- <CodeBuild v-model="shelves" title="货架" /> -->
      <CodeBuild v-model="row" format="PN" title="列" />
      <CodeBuild v-model="column" format="PN" title="层" />
      <div v-if="exampleGridCode" class="example-data">示例数据：{{ exampleGridCode }}</div>
    </div>
    <div slot="footer" style="display: flex; justify-content: flex-start">
      <el-button type="primary" @click="submit">确认</el-button>
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CodeBuild from "@/views/configure/gridCode/components/CodeBuild";
import InputToArray from "@/views/configure/gridCode/components/inputToArray";
import ToCartesian from "@/utils/tools/toCartesian";
import { Validator } from "@/utils/verification";
export default {
  name: "SetGridCode",
  components: {
    CodeBuild,
  },
  data() {
    return {
      dialogVisible: false,
      region: "",
      Initials: "",
      aisleSuffix: "",
      aisle: {
        startCode: "",
        endCode: "",
      },
      row: {
        startCode: "",
        endCode: "",
      },
      column: {
        startCode: "",
        endCode: "",
      },
    };
  },
  props: {
    regionList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    exampleGridCode() {
      const aisleStart = this.aisle.startCode;
      const aisleEnd = this.aisle.endCode;
      const rowStart = this.row.startCode;
      const rowEnd = this.row.endCode;
      const columnStart = this.column.startCode;
      const columnEnd = this.column.endCode;
      if (!aisleStart || !aisleEnd || !rowStart || !rowEnd || !columnStart || !columnEnd) {
        return "";
      }
      return this.buildGridCode(aisleStart, rowStart, columnStart);
    },
  },
  watch: {
    aisleSuffix(val) {
      const next = String(val || "").replace(/[^a-zA-Z]/g, "");
      if (next !== val) {
        this.aisleSuffix = next;
      }
    },
  },
  methods: {
    open: function () {
      this.dialogVisible = true;
    },
    buildGridCode(aisleCode, rowCode, columnCode) {
      const suffix = this.aisleSuffix || "";
      const initials = this.Initials || "";
      return `${initials}${aisleCode}${suffix}-${rowCode}-${columnCode}`;
    },
    submit: function () {
      let validator = new Validator();
      validator.loopAdd(
        [this.Initials, this.aisle.startCode, this.aisle.endCode, this.row.startCode, this.row.endCode, this.column.startCode, this.column.endCode],
        "isNoneEmpty",
        "请填写货格码"
      );
      validator.loopAdd(
        [
          [this.aisle.startCode, this.aisle.endCode],
          [this.row.startCode, this.row.endCode],
          [this.column.startCode, this.column.endCode],
        ],
        "isBigger",
        "大小错误"
      );
      validator.loopAdd_batch(
        [
          this.aisle.startCode,
          this.aisle.endCode,
          this.row.startCode,
          this.row.endCode,
          this.column.startCode,
          this.column.endCode,
        ],
        [
          {
            strategy: "is2LengthNum",
            errorMsg: "数字最小为01,最大为99",
          },
        ]
      );
      if (this.aisleSuffix && /[^a-zA-Z]/.test(this.aisleSuffix)) {
        this.$message.warning("通道后缀仅支持字母");
        return;
      }
      let error = validator.start();
      if (error) {
        this.$message.warning(error);
        return;
      }
      let arr1 = InputToArray.formNum(this.aisle).map((code) => code + (this.aisleSuffix || ""));
      let arr3 = InputToArray.formNum(this.row);
      let arr4 = InputToArray.formNum(this.column);
      let regionCode, regionName;
      for (let i in this.regionList) {
        if (this.regionList[i].id == this.region) {
          regionCode = this.regionList[i].regionCode;
          regionName = this.regionList[i].regionName;
        }
      }
      let gridCodeList = ToCartesian([arr1, arr3, arr4]).map((item) => {
        return this.Initials + item;
      });
      let params = {
        regionName: regionName,
        regionCode: regionCode,
        gridCodeList: gridCodeList
      };
      this.$emit("submit", params);
      this.dialogVisible = false;
    },
    close: function () {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.__div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 100px;
  position: relative;
  top: 0;
  left: 0;
  margin-bottom: 20px;
}

.title__span {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: auto 0;
  font-size: 14px;
  line-height: 32px;
}

.aisle-code>>>.code__div {
  align-items: flex-end;
  flex-wrap: nowrap;
}

.aisle-suffix {
  flex-shrink: 0;
  margin-left: 16px;
}

.aisle-suffix__label {
  padding: 0 0 10px 0;
  font-size: 14px;
  color: #606266;
  line-height: 22px;
  white-space: nowrap;
}

.example-data {
  padding-left: 100px;
  margin-top: 4px;
  color: #f56c6c;
  font-size: 14px;
}
</style>
